import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import "./ClientsStrip.scss";

const API = "https://api.ainfotech.com.np";

const ClientsStrip = () => {
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadClients() {
      try {
        const res = await fetch(`${API}/api/clients/sections`);
        const data = await res.json();
        const sections = Array.isArray(data) ? data : [];

        const allLogos = [];

        sections.forEach((section) => {
          if (!Array.isArray(section.logos)) return;

          section.logos.forEach((logoItem, idx) => {
            if (!logoItem || !logoItem.image) return;

            allLogos.push({
              id: `${section.id}-${idx}`,
              image: `${API}${logoItem.image}`,
              name:
                logoItem.name ||
                logoItem.client_name ||
                section.name ||
                "Client",
            });
          });
        });

        setLogos(allLogos);
      } catch (err) {
        console.error("Failed to load client sections", err);
      } finally {
        setLoading(false);
      }
    }

    loadClients();
  }, []);

  if (loading) {
    return (
      <section className="clientsStrip">
        <div className="container">
          <div className="clientsStrip__head text-center">
            <span className="clientsStrip__eyebrow">OUR CLIENTS</span>
            <h2 className="clientsStrip__title">
              Trusted Across Multiple <span>Industries</span>
            </h2>
            <p className="clientsStrip__sub">
              We proudly work with businesses across IT, construction,
              hospitality and more.
            </p>
          </div>
          <div className="clientsStrip__loading">Loading clients…</div>
        </div>
      </section>
    );
  }

  if (!logos.length) {
    return null; // nothing to show if no clients
  }

  const logoNodes = logos.map((logo) => (
    <div className="clientsStrip__logo" key={logo.id}>
      <div className="clientsStrip__logoInner">
        <img src={logo.image} alt={logo.name} loading="lazy" />
      </div>
    </div>
  ));

  const useMarquee = logos.length > 6;

  return (
    <section className="clientsStrip">
      <div className="container">
        {/* HEADER */}
        <div className="clientsStrip__head text-center">
          <span className="clientsStrip__eyebrow">OUR CLIENTS</span>
          <h2 className="clientsStrip__title">
            Trusted Across Multiple <span>Industries</span>
          </h2>
          <p className="clientsStrip__sub">
            We proudly work with businesses across IT, construction, hospitality
            and more.
          </p>
        </div>

        {/* LOGO STRIP */}
        {useMarquee ? (
          <Marquee
            speed={40}
            gradient={false}
            pauseOnHover={true}
            className="clientsStrip__marquee"
          >
            {logoNodes}
          </Marquee>
        ) : (
          <div className="clientsStrip__row">{logoNodes}</div>
        )}
      </div>
    </section>
  );
};

export default ClientsStrip;
